import { Container } from '@mui/material'
import PropTypes from 'prop-types'
export const AdasContainer = ({ maxWidth = 'lg', sx = {}, ...props }) => <Container maxWidth={maxWidth} sx={sx} {...props} />

AdasContainer.propTypes = {
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'false']),
  sx: PropTypes.object
}
